import React, { Component } from 'react';
import GlobalHelper from '../../../../Common/Helpers/GlobalHelper';

class LimitesCompra extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mensajeEdicionActivo: false,
            descripcionNovedad: "Editado"
        }

        this.obtenerFullDatosNovedad = this.obtenerFullDatosNovedad.bind(this);
    }
    /**
     * 
     * @param {any} activo
     */
    mostrarMensajeParaEdicion(activo) {
        this.setState({ mensajeEdicionActivo: activo });
    }
    /**
     * 
     * @param {any} activo
     */
    mostrarMensajeParaNovedad(descripcionNovedad) {
        this.setState({ descripcionNovedad });
    }
    /**
     * 
     * @param {any} novedad
     */
    obtenerFullDatosNovedad(novedades, empresaDatos, codigoNovedad) {
        const novedad = novedades.find(x => x.NovedadCampoCodigo == codigoNovedad);
        const tieneNovedad = (novedad != undefined);

        let fechaModificacion = "";
        let fecha = "";
        let hora = "";
        let valorAnterior = "";
        let leyenda = {
            descripcion: "",
            estado: "",
            limite: empresaDatos.LimiteCompra,
            limiteFormato: GlobalHelper.ConvertirNumeroMilesMillones(empresaDatos.LimiteCompra),
            tieneNovedad: false
        };

        if (tieneNovedad) {
            fechaModificacion = novedad.FechaHoraModificacion.replace("T", " ").replace("Z", "");
            fecha = fechaModificacion.substring(0, 10).split("-");
            hora = fechaModificacion.substring(16, 11);
            valorAnterior = novedad.ValorAnteriorFormateado ? novedad.ValorAnteriorFormateado : novedad.ValorAnterior;

            leyenda = {
                descripcion: `Editado: ${fecha[2]} - ${fecha[1]}, ${hora} por ${novedad.UsuarioLoginModificacion}. Era: ${valorAnterior}.`,
                estado: `Estado: ${novedad.NovedadEstadoDescripcion}.`,
                tieneNovedad: true,
                limite: novedad.ValorNovedad,
                limiteFormato: GlobalHelper.ConvertirNumeroMilesMillones(novedad.ValorNovedad)
            }
        }

        return leyenda;
    }

    render() {
        const { props } = this;
        const novedad = this.obtenerFullDatosNovedad(props.data.novedadesEmpresaDatos, props.data.empresaDatos, props.codigoNovedad);
        let mensajeEditado = null;

        if (novedad.tieneNovedad) {
            mensajeEditado = <div className="col-xs-12">
                <label className="label-secondary color-azul-claro"
                    onMouseEnter={() => this.mostrarMensajeParaNovedad(novedad.descripcion)}
                    onMouseLeave={() => this.mostrarMensajeParaNovedad("Editado")}>{this.state.descripcionNovedad}</label>
            </div>
        }

        return (
            <div className="row">
                <div className="col-xs-4">
                    <div>
                        <label className="label-primary">Límite de compra</label>
                    </div>
                    <div>
                        <label className="label-secondary edit-panel-lapiz"
                            onMouseEnter={() => this.mostrarMensajeParaEdicion(true)}
                            onMouseLeave={() => this.mostrarMensajeParaEdicion(false)}>$ {novedad.limiteFormato}</label>
                    </div>
                </div>

                {this.state.mensajeEdicionActivo &&
                    <div className="col-xs-8">
                        <label className="label-primary">Se debe modificar en la Distribución de Límites.</label>
                    </div>}

                {mensajeEditado}
            </div>
        );
    }
}

export default LimitesCompra;